import { createElement } from 'react';
import { FormItem } from '@formily/antd';
import { createSchemaField, useForm } from '@formily/react';
import { syncUI, useSchema, useScope } from '../';
import { Alert } from 'antd';
const getComponentName = (componentName) => {
    return componentName.split('.')[0];
};
export const createSchemaComponent = (options) => {
    const { componentName, component } = options;
    const SchemaField = createSchemaField({
        components: {
            [getComponentName(componentName)]: component,
            FormItem,
        },
    });
    const SchemaComponent = (props) => {
        const scope = useScope();
        const form = useForm();
        if (!props.fieldProps) {
            return null;
        }
        const schema = useSchema(props);
        schema.mapProperties((s, key) => {
            s['x-component'] = componentName;
            schema.properties[key] = options?.transform?.(s) || s;
        });
        if (!form) {
            return createElement(Alert, { message: "Formily component can only be used in formily form", type: "error" });
        }
        return createElement(SchemaField, { schema: schema, scope: scope });
    };
    return syncUI(SchemaComponent);
};
export const createVoidSchemaComponent = (options) => {
    return createSchemaComponent({
        ...options,
        transform(schema) {
            schema.type = 'void';
            schema['x-decorator'] = undefined;
            return options?.transform?.(schema);
        },
    });
};
